var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{staticClass:"tab textcenter paddingtop10 paddingbottom10 factab",class:_vm.activeTab ? 'active ' + _vm.width : _vm.width,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.title ? _vm.title : 'Provide a title'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }